// 活動獎項
import CampaignMajorPrize from './CampaignMajorPrize'; // 大獎
import CampaignMinorPrize from './CampaignMinorPrize'; // 小獎
import CampaignBonus from './CampaignBonus'; // bonus 獎勵

const CampaignPrizes = ({ prizes }) => {
    const bonusPrize = prizes?.filter((p) => p?.type === 'bonus'); // bonus 獎項
    const minorPrizes = prizes?.slice(2)?.filter((p) => p?.type !== 'bonus'); // 小獎

    return (
        <div className="mb-[50px] space-y-[16px] [&>div]:flex [&>div]:gap-x-[16px]">
            {/* 大獎 */}
            <div className="usm:!block usm:[&>*]:w-full usm:space-y-[16px]">
                {prizes?.slice(0, 2).map((prize, i) => (
                    <CampaignMajorPrize key={prize?.name + i + 'major'} prize={prize} index={i} />
                ))}
            </div>

            {/* 小獎 */}
            <div className="flex-wrap gap-y-[16px] umd:!block umd:[&>*]:w-full umd:space-y-[16px]">
                {minorPrizes.map((prize, i) => (
                    <CampaignMinorPrize key={prize?.name + i + 'minor'} prize={prize} />
                ))}
            </div>

            {/* bonus 獎勵 */}
            <CampaignBonus prize={bonusPrize?.[0]} />
        </div>
    );
};

export default CampaignPrizes;
